import React, { FC, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Route, Navigate, Routes, useNavigate, useLocation, useParams } from "react-router";
import { Tabs } from "../../../../components";
import {
  Container,
  InstanceName,
  NavWrapper,
  HeadWrapper
} from './styles'
import {
  BillingPage,
  OpenstackPage,
} from './components'


const ConfigurationPage:FC = () => {
  const navigate = useNavigate()
  const [t] = useTranslation()
  const {configurationId} = useParams()
  const [activeTab, setActiveTab] = useState<string>('1')
  const location = useLocation()
  useEffect(() => {
    const lastPathSegment = location.pathname.split('/').pop();
    tabs.forEach((item) => {
      if (lastPathSegment === item.slug) {
        setActiveTab(item.slug);
      }
    });
  }, [location]);
  const [tabs, setTabs] = useState<any[]>( [
    {
      title:t("BILLING"),
      slug:'billing',
      id:'1'
    },
    {
      title:t("OPENSTACK"),
      slug:'openstack',
      id:'2'
    },
  ])

  // if(pageLoading) return <TopProgress loading={pageLoading}/>
  return(
    <Container>
      <HeadWrapper>
        <InstanceName>
          {t("OPENSTACK_SETTINGS")}
        </InstanceName>
      </HeadWrapper>
      <NavWrapper>
        <div>
          <Tabs
            tabs={tabs}
            size='display'
            blockNavigate
            location={activeTab}
            onChange={(e) => {
              navigate(`/settings/configurations/${configurationId}/${e}`)
            }}
          />
        </div>
      </NavWrapper>
      <Routes>
        <Route path="/" element={<Navigate replace to="billing" />} /> 
        <Route path='/billing' element={<BillingPage/>}/>
        <Route path='/openstack' element={<OpenstackPage/>}/>
      </Routes>
    </Container>
  )
}

export default ConfigurationPage